export default __webpack_public_path__ + "static/media/storytelling.7ffdab7d.svg";